var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function () {
  var e = {
      677: function _(e, t, n) {
        "use strict";

        n.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var i = n(609),
          o = n.n(i)()(function (e) {
            return e[1];
          });
        o.push([e.id, ":root{--ck-color-mention-background:rgba(153,0,48,0.1);--ck-color-mention-text:#990030}.ck-content .mention{background:var(--ck-color-mention-background);color:var(--ck-color-mention-text)}", ""]);
        var r = o;
      },
      216: function _(e, t, n) {
        "use strict";

        n.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var i = n(609),
          o = n.n(i)()(function (e) {
            return e[1];
          });
        o.push([e.id, ":root{--ck-mention-list-max-height:300px}.ck.ck-mentions{max-height:var(--ck-mention-list-max-height);overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain}.ck.ck-mentions>.ck-list__item{overflow:hidden;flex-shrink:0}", ""]);
        var r = o;
      },
      609: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
            }).join("");
          }, t.i = function (e, n, i) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var o = {};
            if (i) for (var r = 0; r < this.length; r++) {
              var s = this[r][0];
              null != s && (o[s] = !0);
            }
            for (var a = 0; a < e.length; a++) {
              var c = [].concat(e[a]);
              i && o[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c));
            }
          }, t;
        };
      },
      62: function _(e, t, n) {
        "use strict";

        var i,
          o = function o() {
            return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
          },
          r = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var n = document.querySelector(t);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                  n = n.contentDocument.head;
                } catch (e) {
                  n = null;
                }
                e[t] = n;
              }
              return e[t];
            };
          }(),
          s = [];
        function a(e) {
          for (var t = -1, n = 0; n < s.length; n++) if (s[n].identifier === e) {
            t = n;
            break;
          }
          return t;
        }
        function c(e, t) {
          for (var n = {}, i = [], o = 0; o < e.length; o++) {
            var r = e[o],
              c = t.base ? r[0] + t.base : r[0],
              d = n[c] || 0,
              l = "".concat(c, " ").concat(d);
            n[c] = d + 1;
            var u = a(l),
              m = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== u ? (s[u].references++, s[u].updater(m)) : s.push({
              identifier: l,
              updater: p(m, t),
              references: 1
            }), i.push(l);
          }
          return i;
        }
        function d(e) {
          var t = document.createElement("style"),
            i = e.attributes || {};
          if (void 0 === i.nonce) {
            var o = n.nc;
            o && (i.nonce = o);
          }
          if (Object.keys(i).forEach(function (e) {
            t.setAttribute(e, i[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var s = r(e.insert || "head");
            if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s.appendChild(t);
          }
          return t;
        }
        var l,
          u = (l = [], function (e, t) {
            return l[e] = t, l.filter(Boolean).join("\n");
          });
        function m(e, t, n, i) {
          var o = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
          if (e.styleSheet) e.styleSheet.cssText = u(t, o);else {
            var r = document.createTextNode(o),
              s = e.childNodes;
            s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(r, s[t]) : e.appendChild(r);
          }
        }
        function h(e, t, n) {
          var i = n.css,
            o = n.media,
            r = n.sourceMap;
          if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), r && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = i;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(i));
          }
        }
        var f = null,
          g = 0;
        function p(e, t) {
          var n, i, o;
          if (t.singleton) {
            var r = g++;
            n = f || (f = d(t)), i = m.bind(null, n, r, !1), o = m.bind(null, n, r, !0);
          } else n = d(t), i = h.bind(null, n, t), o = function o() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(n);
          };
          return i(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              i(e = t);
            } else o();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
          var n = c(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var i = 0; i < n.length; i++) {
                var o = a(n[i]);
                s[o].references--;
              }
              for (var r = c(e, t), d = 0; d < n.length; d++) {
                var l = a(n[d]);
                0 === s[l].references && (s[l].updater(), s.splice(l, 1));
              }
              n = r;
            }
          };
        };
      },
      704: function _(e, t, n) {
        e.exports = n(79)("./src/core.js");
      },
      181: function _(e, t, n) {
        e.exports = n(79)("./src/typing.js");
      },
      273: function _(e, t, n) {
        e.exports = n(79)("./src/ui.js");
      },
      209: function _(e, t, n) {
        e.exports = n(79)("./src/utils.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function n(i) {
    var o = t[i];
    if (void 0 !== o) return o.exports;
    var r = t[i] = {
      id: i,
      exports: {}
    };
    return e[i](r, r.exports, n), r.exports;
  }
  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
      enumerable: !0,
      get: t[i]
    });
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var i = {};
  (function () {
    "use strict";

    n.r(i), n.d(i, {
      Mention: function Mention() {
        return ae;
      },
      MentionEditing: function MentionEditing() {
        return r;
      },
      MentionUI: function MentionUI() {
        return X;
      }
    });
    var e = n(704),
      t = n(209);
    var o = /*#__PURE__*/function (_e$Command) {
      _inherits(o, _e$Command);
      function o() {
        _classCallCheck(this, o);
        return _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments));
      }
      _createClass(o, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
            t = e.document;
          this.isEnabled = e.schema.checkAttributeInSelection(t.selection, "mention");
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var n = this.editor.model,
            i = n.document.selection,
            o = "string" == typeof e.mention ? {
              id: e.mention
            } : e.mention,
            r = o.id,
            a = e.range || i.getFirstRange(),
            c = e.text || r,
            d = s({
              _text: c,
              id: r
            }, o);
          if (1 != e.marker.length) throw new t.CKEditorError("mentioncommand-incorrect-marker", this);
          if (r.charAt(0) != e.marker) throw new t.CKEditorError("mentioncommand-incorrect-id", this);
          n.change(function (e) {
            var o = (0, t.toMap)(i.getAttributes()),
              r = new Map(o.entries());
            r.set("mention", d), n.insertContent(e.createText(c, r), a), n.insertContent(e.createText(" ", o), a.start.getShiftedBy(c.length));
          });
        }
      }]);
      return o;
    }(e.Command);
    var r = /*#__PURE__*/function (_e$Plugin) {
      _inherits(r, _e$Plugin);
      function r() {
        _classCallCheck(this, r);
        return _possibleConstructorReturn(this, _getPrototypeOf(r).apply(this, arguments));
      }
      _createClass(r, [{
        key: "init",
        value: function init() {
          var e = this.editor,
            t = e.model,
            n = t.document;
          t.schema.extend("$text", {
            allowAttributes: "mention"
          }), e.conversion.for("upcast").elementToAttribute({
            view: {
              name: "span",
              key: "data-mention",
              classes: "mention"
            },
            model: {
              key: "mention",
              value: function value(e) {
                return a(e);
              }
            }
          }), e.conversion.for("downcast").attributeToElement({
            model: "mention",
            view: d
          }), e.conversion.for("downcast").add(c), n.registerPostFixer(function (e) {
            return function (e, t, n) {
              var i = t.differ.getChanges();
              var o = !1;
              var _iterator = _createForOfIteratorHelper(i),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _t = _step.value;
                  var _i = _t.position;
                  if ("$text" == _t.name) {
                    var _t2 = _i.textNode && _i.textNode.nextSibling;
                    o = u(_i.textNode, e) || o, o = u(_t2, e) || o, o = u(_i.nodeBefore, e) || o, o = u(_i.nodeAfter, e) || o;
                  }
                  if ("$text" != _t.name && "insert" == _t.type) {
                    var _t3 = _i.nodeAfter;
                    var _iterator2 = _createForOfIteratorHelper(e.createRangeIn(_t3).getItems()),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var _n = _step2.value;
                        o = u(_n, e) || o;
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                  if ("insert" == _t.type && n.isInline(_t.name)) {
                    var _t4 = _i.nodeAfter && _i.nodeAfter.nextSibling;
                    o = u(_i.nodeBefore, e) || o, o = u(_t4, e) || o;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return o;
            }(e, n, t.schema);
          }), n.registerPostFixer(function (e) {
            return function (e, t) {
              var n = t.differ.getChanges();
              var i = !1;
              var _iterator3 = _createForOfIteratorHelper(n),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _t5 = _step3.value;
                  if ("attribute" === _t5.type && "mention" != _t5.attributeKey) {
                    var _n2 = _t5.range.start.nodeBefore,
                      _o = _t5.range.end.nodeAfter;
                    for (var _i2 = 0, _arr = [_n2, _o]; _i2 < _arr.length; _i2++) {
                      var _r = _arr[_i2];
                      l(_r) && _r.getAttribute(_t5.attributeKey) != _t5.attributeNewValue && (e.setAttribute(_t5.attributeKey, _t5.attributeNewValue, _r), i = !0);
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              return i;
            }(e, n);
          }), n.registerPostFixer(function (e) {
            return function (e, t) {
              var n = t.selection,
                i = n.focus;
              if (n.isCollapsed && n.hasAttribute("mention") && function (e) {
                var t = e.isAtStart;
                return e.nodeBefore && e.nodeBefore.is("$text") || t;
              }(i)) return e.removeSelectionAttribute("mention"), !0;
            }(e, n);
          }), e.commands.add("mention", new o(e));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "MentionEditing";
        }
      }]);
      return r;
    }(e.Plugin);
    function s(e, n) {
      return Object.assign({
        uid: (0, t.uid)()
      }, e, n || {});
    }
    function a(e, t) {
      var n = e.getAttribute("data-mention"),
        i = e.getChild(0);
      if (!i) return;
      return s({
        id: n,
        _text: i.data
      }, t);
    }
    function c(e) {
      e.on("attribute:mention", function (e, t, n) {
        var i = t.attributeNewValue;
        if (!t.item.is("$textProxy") || !i) return;
        var o = t.range.start;
        (o.textNode || o.nodeAfter).data != i._text && n.consumable.consume(t.item, e.name);
      }, {
        priority: "highest"
      });
    }
    function d(e, _ref) {
      var t = _ref.writer;
      if (!e) return;
      var n = {
          class: "mention",
          "data-mention": e.id
        },
        i = {
          id: e.uid,
          priority: 20
        };
      return t.createAttributeElement("span", n, i);
    }
    function l(e) {
      if (!e || !e.is("$text") && !e.is("$textProxy") || !e.hasAttribute("mention")) return !1;
      return e.data != e.getAttribute("mention")._text;
    }
    function u(e, t) {
      return !!l(e) && (t.removeAttribute("mention", e), !0);
    }
    var m = n(273),
      h = n(181);
    var f = function f(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
    var g = "object" == typeof global && global && global.Object === Object && global;
    var p = "object" == typeof self && self && self.Object === Object && self;
    var v = g || p || Function("return this")();
    var b = function b() {
      return v.Date.now();
    };
    var w = /\s/;
    var x = function x(e) {
      for (var t = e.length; t-- && w.test(e.charAt(t)););
      return t;
    };
    var y = /^\s+/;
    var k = function k(e) {
      return e ? e.slice(0, x(e) + 1).replace(y, "") : e;
    };
    var _ = v.Symbol;
    var C = Object.prototype,
      A = C.hasOwnProperty,
      T = C.toString,
      I = _ ? _.toStringTag : void 0;
    var M = function M(e) {
      var t = A.call(e, I),
        n = e[I];
      try {
        e[I] = void 0;
        var i = !0;
      } catch (e) {}
      var o = T.call(e);
      return i && (t ? e[I] = n : delete e[I]), o;
    };
    var R = Object.prototype.toString;
    var S = function S(e) {
      return R.call(e);
    };
    var V = _ ? _.toStringTag : void 0;
    var E = function E(e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : V && V in Object(e) ? M(e) : S(e);
    };
    var j = function j(e) {
      return null != e && "object" == typeof e;
    };
    var O = function O(e) {
      return "symbol" == typeof e || j(e) && "[object Symbol]" == E(e);
    };
    var P = /^[-+]0x[0-9a-f]+$/i,
      N = /^0b[01]+$/i,
      U = /^0o[0-7]+$/i,
      F = parseInt;
    var B = function B(e) {
      if ("number" == typeof e) return e;
      if (O(e)) return NaN;
      if (f(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = f(t) ? t + "" : t;
      }
      if ("string" != typeof e) return 0 === e ? e : +e;
      e = k(e);
      var n = N.test(e);
      return n || U.test(e) ? F(e.slice(2), n ? 2 : 8) : P.test(e) ? NaN : +e;
    };
    var $ = Math.max,
      q = Math.min;
    var L = function L(e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        c,
        d = 0,
        l = !1,
        u = !1,
        m = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      function h(t) {
        var n = i,
          r = o;
        return i = o = void 0, d = t, s = e.apply(r, n);
      }
      function g(e) {
        return d = e, a = setTimeout(v, t), l ? h(e) : s;
      }
      function p(e) {
        var n = e - c;
        return void 0 === c || n >= t || n < 0 || u && e - d >= r;
      }
      function v() {
        var e = b();
        if (p(e)) return w(e);
        a = setTimeout(v, function (e) {
          var n = t - (e - c);
          return u ? q(n, r - (e - d)) : n;
        }(e));
      }
      function w(e) {
        return a = void 0, m && i ? h(e) : (i = o = void 0, s);
      }
      function x() {
        var e = b(),
          n = p(e);
        if (i = arguments, o = this, c = e, n) {
          if (void 0 === a) return g(c);
          if (u) return clearTimeout(a), a = setTimeout(v, t), h(c);
        }
        return void 0 === a && (a = setTimeout(v, t)), s;
      }
      return t = B(t) || 0, f(n) && (l = !!n.leading, r = (u = "maxWait" in n) ? $(B(n.maxWait) || 0, t) : r, m = "trailing" in n ? !!n.trailing : m), x.cancel = function () {
        void 0 !== a && clearTimeout(a), d = 0, i = c = o = a = void 0;
      }, x.flush = function () {
        return void 0 === a ? s : w(b());
      }, x;
    };
    var D = n(62),
      K = n.n(D),
      W = n(216),
      Z = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    K()(W.Z, Z);
    W.Z.locals;
    var H = /*#__PURE__*/function (_m$ListView) {
      _inherits(H, _m$ListView);
      function H(e) {
        var _this;
        _classCallCheck(this, H);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(H).call(this, e)), _this.extendTemplate({
          attributes: {
            class: ["ck-mentions"],
            tabindex: "-1"
          }
        });
        return _this;
      }
      _createClass(H, [{
        key: "selectFirst",
        value: function selectFirst() {
          this.select(0);
        }
      }, {
        key: "selectNext",
        value: function selectNext() {
          var e = this.selected,
            t = this.items.getIndex(e);
          this.select(t + 1);
        }
      }, {
        key: "selectPrevious",
        value: function selectPrevious() {
          var e = this.selected,
            t = this.items.getIndex(e);
          this.select(t - 1);
        }
      }, {
        key: "select",
        value: function select(e) {
          var t = 0;
          e > 0 && e < this.items.length ? t = e : e < 0 && (t = this.items.length - 1);
          var n = this.items.get(t);
          this.selected !== n && (this.selected && this.selected.removeHighlight(), n.highlight(), this.selected = n, this._isItemVisibleInScrolledArea(n) || (this.element.scrollTop = n.element.offsetTop));
        }
      }, {
        key: "executeSelected",
        value: function executeSelected() {
          this.selected.fire("execute");
        }
      }, {
        key: "_isItemVisibleInScrolledArea",
        value: function _isItemVisibleInScrolledArea(e) {
          return new t.Rect(this.element).contains(new t.Rect(e.element));
        }
      }]);
      return H;
    }(m.ListView);
    var J = /*#__PURE__*/function (_m$View) {
      _inherits(J, _m$View);
      function J(e, t) {
        var _this2;
        _classCallCheck(this, J);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(J).call(this, e)), _this2.template = !1, _this2.domElement = t, _this2.domElement.classList.add("ck-button"), _this2.set("isOn", !1), _this2.on("change:isOn", function (e, t, n) {
          n ? (_this2.domElement.classList.add("ck-on"), _this2.domElement.classList.remove("ck-off")) : (_this2.domElement.classList.add("ck-off"), _this2.domElement.classList.remove("ck-on"));
        }), _this2.listenTo(_this2.domElement, "click", function () {
          _this2.fire("execute");
        });
        return _this2;
      }
      _createClass(J, [{
        key: "render",
        value: function render() {
          _superPropGet(J, "render", this, 3)([]), this.element = this.domElement;
        }
      }]);
      return J;
    }(m.View);
    var z = /*#__PURE__*/function (_m$ListItemView) {
      _inherits(z, _m$ListItemView);
      function z() {
        _classCallCheck(this, z);
        return _possibleConstructorReturn(this, _getPrototypeOf(z).apply(this, arguments));
      }
      _createClass(z, [{
        key: "highlight",
        value: function highlight() {
          this.children.first.isOn = !0;
        }
      }, {
        key: "removeHighlight",
        value: function removeHighlight() {
          this.children.first.isOn = !1;
        }
      }]);
      return z;
    }(m.ListItemView);
    var G = [t.keyCodes.arrowup, t.keyCodes.arrowdown, t.keyCodes.esc],
      Q = [t.keyCodes.enter, t.keyCodes.tab];
    var X = /*#__PURE__*/function (_e$Plugin2) {
      _inherits(X, _e$Plugin2);
      _createClass(X, null, [{
        key: "pluginName",
        get: function get() {
          return "MentionUI";
        }
      }, {
        key: "requires",
        get: function get() {
          return [m.ContextualBalloon];
        }
      }]);
      function X(e) {
        var _this3;
        _classCallCheck(this, X);
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(X).call(this, e)), _this3._mentionsView = _this3._createMentionView(), _this3._mentionsConfigurations = new Map(), _this3._requestFeedDebounced = L(_this3._requestFeed, 100), e.config.define("mention", {
          feeds: []
        });
        return _this3;
      }
      _createClass(X, [{
        key: "init",
        value: function init() {
          var _this4 = this;
          var e = this.editor,
            n = e.config.get("mention.commitKeys") || Q,
            i = G.concat(n);
          this._balloon = e.plugins.get(m.ContextualBalloon), e.editing.view.document.on("keydown", function (e, o) {
            var r;
            r = o.keyCode, i.includes(r) && _this4._isUIVisible && (o.preventDefault(), e.stop(), o.keyCode == t.keyCodes.arrowdown && _this4._mentionsView.selectNext(), o.keyCode == t.keyCodes.arrowup && _this4._mentionsView.selectPrevious(), n.includes(o.keyCode) && _this4._mentionsView.executeSelected(), o.keyCode == t.keyCodes.esc && _this4._hideUIAndRemoveMarker());
          }, {
            priority: "highest"
          }), (0, m.clickOutsideHandler)({
            emitter: this._mentionsView,
            activator: function activator() {
              return _this4._isUIVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this4._hideUIAndRemoveMarker();
            }
          });
          var o = e.config.get("mention.feeds");
          var _iterator4 = _createForOfIteratorHelper(o),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _e = _step4.value;
              var _n3 = _e.feed,
                _i3 = _e.marker;
              if (!ie(_i3)) throw new t.CKEditorError("mentionconfig-incorrect-marker", null, {
                marker: _i3
              });
              var _o2 = {
                marker: _i3,
                feedCallback: "function" == typeof _n3 ? _n3.bind(this.editor) : ne(_n3),
                itemRenderer: _e.itemRenderer
              };
              this._mentionsConfigurations.set(_i3, _o2);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          this._setupTextWatcher(o), this.listenTo(e, "change:isReadOnly", function () {
            _this4._hideUIAndRemoveMarker();
          }), this.on("requestFeed:response", function (e, t) {
            return _this4._handleFeedResponse(t);
          }), this.on("requestFeed:error", function () {
            return _this4._hideUIAndRemoveMarker();
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _superPropGet(X, "destroy", this, 3)([]), this._mentionsView.destroy();
        }
      }, {
        key: "_createMentionView",
        value: function _createMentionView() {
          var _this5 = this;
          var e = this.editor.locale,
            n = new H(e);
          return this._items = new t.Collection(), n.items.bindTo(this._items).using(function (t) {
            var i = t.item,
              o = t.marker,
              r = _this5.editor.config.get("mention.dropdownLimit") || 10;
            if (n.items.length >= r) return;
            var s = new z(e),
              a = _this5._renderItem(i, o);
            return a.delegate("execute").to(s), s.children.add(a), s.item = i, s.marker = o, s.on("execute", function () {
              n.fire("execute", {
                item: i,
                marker: o
              });
            }), s;
          }), n.on("execute", function (e, t) {
            var n = _this5.editor,
              i = n.model,
              o = t.item,
              r = t.marker,
              s = n.model.markers.get("mention"),
              a = i.createPositionAt(i.document.selection.focus),
              c = i.createPositionAt(s.getStart()),
              d = i.createRange(c, a);
            _this5._hideUIAndRemoveMarker(), n.execute("mention", {
              mention: o,
              text: o.text,
              marker: r,
              range: d
            }), n.editing.view.focus();
          }), n;
        }
      }, {
        key: "_getItemRenderer",
        value: function _getItemRenderer(e) {
          var _this$_mentionsConfig = this._mentionsConfigurations.get(e),
            t = _this$_mentionsConfig.itemRenderer;
          return t;
        }
      }, {
        key: "_requestFeed",
        value: function _requestFeed(e, n) {
          var _this6 = this;
          this._lastRequested = n;
          var _this$_mentionsConfig2 = this._mentionsConfigurations.get(e),
            i = _this$_mentionsConfig2.feedCallback,
            o = i(n);
          o instanceof Promise ? o.then(function (t) {
            _this6._lastRequested == n ? _this6.fire("requestFeed:response", {
              feed: t,
              marker: e,
              feedText: n
            }) : _this6.fire("requestFeed:discarded", {
              feed: t,
              marker: e,
              feedText: n
            });
          }).catch(function (n) {
            _this6.fire("requestFeed:error", {
              error: n
            }), (0, t.logWarning)("mention-feed-callback-error", {
              marker: e
            });
          }) : this.fire("requestFeed:response", {
            feed: o,
            marker: e,
            feedText: n
          });
        }
      }, {
        key: "_setupTextWatcher",
        value: function _setupTextWatcher(e) {
          var _this7 = this;
          var t = this.editor,
            n = e.map(function (e) {
              return _objectSpread({}, e, {
                pattern: te(e.marker, e.minimumCharacters || 0)
              });
            }),
            i = new h.TextWatcher(t.model, function (e) {
              return function (t) {
                var n = ee(e, t);
                if (!n) return !1;
                var i = 0;
                0 !== n.position && (i = n.position - 1);
                var o = t.substring(i);
                return n.pattern.test(o);
              };
            }(n));
          i.on("matched", function (e, i) {
            var o = ee(n, i.text),
              r = t.model.document.selection.focus;
            if (function (e) {
              var t = e.textNode && e.textNode.hasAttribute("mention"),
                n = e.nodeBefore;
              return t || n && n.is("$text") && n.hasAttribute("mention");
            }(r)) return void _this7._hideUIAndRemoveMarker();
            var s = function (e, t) {
                var n = 0;
                0 !== e.position && (n = e.position - 1);
                var i = te(e.marker, 0),
                  o = t.substring(n);
                return o.match(i)[2];
              }(o, i.text),
              a = o.marker.length + s.length,
              c = r.getShiftedBy(-a),
              d = r.getShiftedBy(-s.length),
              l = t.model.createRange(c, d);
            if (oe(t)) {
              var _e2 = t.model.markers.get("mention");
              t.model.change(function (t) {
                t.updateMarker(_e2, {
                  range: l
                });
              });
            } else t.model.change(function (e) {
              e.addMarker("mention", {
                range: l,
                usingOperation: !1,
                affectsData: !1
              });
            });
            _this7._requestFeedDebounced(o.marker, s);
          }), i.on("unmatched", function () {
            _this7._hideUIAndRemoveMarker();
          });
          var o = t.commands.get("mention");
          return i.bind("isEnabled").to(o), i;
        }
      }, {
        key: "_handleFeedResponse",
        value: function _handleFeedResponse(e) {
          var t = e.feed,
            n = e.marker;
          if (!oe(this.editor)) return;
          this._items.clear();
          var _iterator5 = _createForOfIteratorHelper(t),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e3 = _step5.value;
              var _t6 = "object" != typeof _e3 ? {
                id: _e3,
                text: _e3
              } : _e3;
              this._items.add({
                item: _t6,
                marker: n
              });
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          var i = this.editor.model.markers.get("mention");
          this._items.length ? this._showOrUpdateUI(i) : this._hideUIAndRemoveMarker();
        }
      }, {
        key: "_showOrUpdateUI",
        value: function _showOrUpdateUI(e) {
          this._isUIVisible ? this._balloon.updatePosition(this._getBalloonPanelPositionData(e, this._mentionsView.position)) : this._balloon.add({
            view: this._mentionsView,
            position: this._getBalloonPanelPositionData(e, this._mentionsView.position),
            singleViewMode: !0
          }), this._mentionsView.position = this._balloon.view.position, this._mentionsView.selectFirst();
        }
      }, {
        key: "_hideUIAndRemoveMarker",
        value: function _hideUIAndRemoveMarker() {
          this._balloon.hasView(this._mentionsView) && this._balloon.remove(this._mentionsView), oe(this.editor) && this.editor.model.change(function (e) {
            return e.removeMarker("mention");
          }), this._mentionsView.position = void 0;
        }
      }, {
        key: "_renderItem",
        value: function _renderItem(e, t) {
          var n = this.editor;
          var i,
            o = e.id;
          var r = this._getItemRenderer(t);
          if (r) {
            var _t7 = r(e);
            "string" != typeof _t7 ? i = new J(n.locale, _t7) : o = _t7;
          }
          if (!i) {
            var _e4 = new m.ButtonView(n.locale);
            _e4.label = o, _e4.withText = !0, i = _e4;
          }
          return i;
        }
      }, {
        key: "_getBalloonPanelPositionData",
        value: function _getBalloonPanelPositionData(e, n) {
          var _this8 = this;
          var i = this.editor,
            o = i.editing,
            r = o.view.domConverter,
            s = o.mapper;
          return {
            target: function target() {
              var n = e.getRange();
              "$graveyard" == n.start.root.rootName && (n = i.model.document.selection.getFirstRange());
              var o = s.toViewRange(n);
              return t.Rect.getDomRangeRects(r.viewRangeToDom(o)).pop();
            },
            limiter: function limiter() {
              var e = _this8.editor.editing.view,
                t = e.document.selection.editableElement;
              return t ? e.domConverter.mapViewToDom(t.root) : null;
            },
            positions: Y(n)
          };
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView === this._mentionsView;
        }
      }]);
      return X;
    }(e.Plugin);
    function Y(e) {
      var t = {
        caret_se: function caret_se(e) {
          return {
            top: e.bottom + 3,
            left: e.right,
            name: "caret_se",
            config: {
              withArrow: !1
            }
          };
        },
        caret_ne: function caret_ne(e, t) {
          return {
            top: e.top - t.height - 3,
            left: e.right,
            name: "caret_ne",
            config: {
              withArrow: !1
            }
          };
        },
        caret_sw: function caret_sw(e, t) {
          return {
            top: e.bottom + 3,
            left: e.right - t.width,
            name: "caret_sw",
            config: {
              withArrow: !1
            }
          };
        },
        caret_nw: function caret_nw(e, t) {
          return {
            top: e.top - t.height - 3,
            left: e.right - t.width,
            name: "caret_nw",
            config: {
              withArrow: !1
            }
          };
        }
      };
      return Object.prototype.hasOwnProperty.call(t, e) ? [t[e]] : [t.caret_se, t.caret_sw, t.caret_ne, t.caret_nw];
    }
    function ee(e, t) {
      var n;
      var _iterator6 = _createForOfIteratorHelper(e),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _i4 = _step6.value;
          var _e5 = t.lastIndexOf(_i4.marker);
          _e5 > 0 && !t.substring(_e5 - 1).match(_i4.pattern) || (!n || _e5 >= n.position) && (n = {
            marker: _i4.marker,
            position: _e5,
            minimumCharacters: _i4.minimumCharacters,
            pattern: _i4.pattern
          });
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return n;
    }
    function te(e, n) {
      var i = 0 == n ? "*" : "{".concat(n, ",}"),
        o = t.env.features.isRegExpUnicodePropertySupported ? "\\p{Ps}\\p{Pi}\"'" : "\\(\\[{\"'";
      return new RegExp("(?:^|[ ".concat(o, "])([").concat(e, "])(.").concat(i, ")$"), "u");
    }
    function ne(e) {
      return function (t) {
        return e.filter(function (e) {
          return ("string" == typeof e ? e : String(e.id)).toLowerCase().includes(t.toLowerCase());
        });
      };
    }
    function ie(e) {
      return e && 1 == e.length;
    }
    function oe(e) {
      return e.model.markers.has("mention");
    }
    var re = n(677),
      se = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    K()(re.Z, se);
    re.Z.locals;
    var ae = /*#__PURE__*/function (_e$Plugin3) {
      _inherits(ae, _e$Plugin3);
      function ae() {
        _classCallCheck(this, ae);
        return _possibleConstructorReturn(this, _getPrototypeOf(ae).apply(this, arguments));
      }
      _createClass(ae, [{
        key: "toMentionAttribute",
        value: function toMentionAttribute(e, t) {
          return a(e, t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Mention";
        }
      }, {
        key: "requires",
        get: function get() {
          return [r, X];
        }
      }]);
      return ae;
    }(e.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).mention = i;
})();